import React, { useEffect, useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getFormsMonthlyStats } from "../../api/work-order-formsAPI";

const FormsMonthlyActivityChart = () => {
  const [stats, setStats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setIsLoading(true);
        const response = await getFormsMonthlyStats();
        setStats(Array.isArray(response) ? response : []);
      } catch (err) {
        console.error("Failed to load forms monthly stats", err);
        setError("Unable to load monthly stats");
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, []);

  const chartData = useMemo(() => {
    if (!stats.length) {
      return {
        series: [],
        options: {},
      };
    }

    const categories = stats.map((item) => item.month);
    const startedData = stats.map((item) => Number(item.started ?? 0));
    const completedData = stats.map((item) => Number(item.completed ?? 0));

    return {
      series: [
        { name: "Started", data: startedData },
        { name: "Completed", data: completedData },
      ],
      options: {
        chart: {
          type: "bar",
          stacked: false,
          toolbar: { show: false },
        },
        colors: ["#3B82F6", "#22C55E"],
        plotOptions: {
          bar: {
            columnWidth: "45%",
            borderRadius: 6,
          },
        },
        dataLabels: { enabled: false },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
        grid: {
          borderColor: "#D1D5DB",
          strokeDashArray: 2,
        },
        xaxis: {
          categories,
          labels: { rotate: -45 },
        },
        yaxis: {
          labels: {
            formatter: (value) => Math.round(value),
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (value) => `${value} forms`,
          },
        },
      },
    };
  }, [stats]);

  return (
    <div className='col-xxl-8'>
      <div className='card h-100'>
        <div className='card-body p-24 d-flex flex-column gap-16'>
          <h6 className='mb-0 fw-bold text-lg'>Forms Started vs Completed (Last 12 Months)</h6>
          {isLoading ? (
            <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
              <span className='text-secondary-600 text-sm'>Loading chart...</span>
            </div>
          ) : error ? (
            <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
              <span className='text-danger-main text-sm'>{error}</span>
            </div>
          ) : stats.length === 0 ? (
            <div className='flex-grow-1 d-flex align-items-center justify-content-center'>
              <span className='text-secondary-600 text-sm'>No form activity for the selected period.</span>
            </div>
          ) : (
            <div id='formsMonthlyActivityChart' className='apexcharts-tooltip-style-1'>
              <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type='bar'
                height={320}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormsMonthlyActivityChart;
